import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/saju/$sajuType/result/detail')({
  validateSearch: (search: Record<string, unknown>): { hashKey: string } => {
    const hashKey = search.hashKey as string
    if (!hashKey) {
      throw new Error('분석 결과를 찾을 수 없어요.')
    }
    return { hashKey }
  },
  component: () => {
    return <div>유료 상세 분석 결과 페이지 (구현 예정)</div>
  },
})
